export class setCurrentTime {
  constructor () {
    this.el = document.querySelector('[data-current-time]')
    this.date = new Date()

    this.start()

  }

  // Locale is pinned to 'en-AU' with an explicit Melbourne timeZone so a
  // visitor's own browser timezone/locale never leaks into the displayed
  // time — every visitor sees genuine Melbourne local time.
  formattedTime() {
    return this.date.toLocaleTimeString('en-AU', { timeZone: 'Australia/Melbourne' })
  }

  clock() {
    this.date = new Date()
    this.el.innerHTML = this.formattedTime()

    // console.log(this.el, 'clock: update the count')
  }

  start() {
    this.el = document.querySelector('[data-current-time]')

    if (!this.el) return

    this.el.innerHTML = this.formattedTime()
    this.time = setInterval(this.clock.bind(this), 1000)

    // console.log(this.el, 'clock: start the count')
  }

  clear() {
   clearInterval(this.time)
  }

}